import React, { useState } from "react";
import SparkLine from "../sparkline/SparkLine";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

const SparkLineAdvanced: React.FC<SparkLineProps> = props => {
  const [currentBiggestValueLabelWidth, setCurrentBiggestValueLabelWidth] = useState<number>(0);
  const [displayCharts, setDisplayCharts] = useState<boolean>(false);
  const reportedIndexesRef = React.useRef<Set<number>>(new Set());
  const chartsCount = props.isMultipleCharts ? props.multipleCharts.length + 1 : 1;

  const handleSetCurrentBiggestValueLabelWidth = (width: number, chartIndex: number) => {
    setCurrentBiggestValueLabelWidth(prev => Math.max(prev, width));

    if (!reportedIndexesRef.current.has(chartIndex)) {
      reportedIndexesRef.current.add(chartIndex);
    }

    if (reportedIndexesRef.current.size === chartsCount) {
      setDisplayCharts(true);
    }
  };

  if (props.isMultipleCharts) {
    return (
      <div className="flex flex-column gap-3">
        <SparkLine
          {...props}
          chartIndex={0}
          advanced
          generalProperties={props.generalProperties}
          isMultipleCharts
          currentBiggestValueWidth={currentBiggestValueLabelWidth}
          setCurrentBiggestValueWidth={handleSetCurrentBiggestValueLabelWidth}
          displayCharts={displayCharts}
        />
        {props.multipleCharts.map((chart, index) => (
          <SparkLine
            key={chart.id ?? index}
            {...chart}
            chartIndex={index + 1}
            advanced
            generalProperties={props.generalProperties}
            isMultipleCharts
            currentBiggestValueWidth={currentBiggestValueLabelWidth}
            setCurrentBiggestValueWidth={handleSetCurrentBiggestValueLabelWidth}
            displayCharts={displayCharts}
          />
        ))}
      </div>
    );
  }
  return <SparkLine {...props} advanced />;
};

export default SparkLineAdvanced;
